import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SearchSiteComponent} from './search-site.component';
import {SiteListComponent} from './site-list/site-list.component';
import {MatIconModule} from '@angular/material/icon';
import {ButtonModule} from '../../components/dumb/button/button.module';
import {TooltipPanelModule} from '../../components/dumb/tooltip-panel/tooltip-panel.module';
import {SearchInputModule} from '../../components/dumb/search-input/search-input.module';
import {ProgressSpinnerModule} from '../../components/dumb/progress-spinner/progress-spinner.module';
import {WalkThroughModule} from '../walkthrough/walkthrough.module';
import {ReactiveFormsModule} from '@angular/forms';
import {DirectivesModule} from 'src/app/common/directives/directives.module';
import {TooltipPanelWrapperComponent} from '../../components/dumb/tooltip-panel-wrapper/tooltip-panel-wrapper.component';

@NgModule({
  declarations: [SearchSiteComponent, SiteListComponent],
  imports: [
    CommonModule,
    MatIconModule,
    ButtonModule,
    TooltipPanelModule,
    SearchInputModule,
    ProgressSpinnerModule,
    WalkThroughModule,
    ReactiveFormsModule,
    DirectivesModule,
    TooltipPanelWrapperComponent,
  ],
  exports: [SearchSiteComponent, SearchSiteComponent, SiteListComponent],
})
export class SearchSiteModule {}
